import { ReactNode } from "react";

interface InfoItemProps {
  title?: string;
  children?: ReactNode;
  rootClassName?: string;
  titleClassName?: string;
  className?: string;
}

export default function InfoItem({
  title,
  children,
  rootClassName = "",
  titleClassName = "",
  className = "",
}: InfoItemProps) {
  return (
    <li
      className={`flex items-center border-b py-2 border-extra-light ${rootClassName}`}
    >
      {title ? (
        <h4
          className={`text-extra-gray font-medium w-[200px] ${titleClassName}`}
        >
          {title}
        </h4>
      ) : null}
      <div className={`flex-1 font-medium text-display-body ${className}`}>
        {children ?? "N/A"}
      </div>
    </li>
  );
}
